/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';

export interface UrgentIconProps {
  color?: string;
  size?: IconSize | number;
}

/**
 * Defines the Design Language System (DLS) Urgent Icon component.
 */
export const UrgentIcon = ({color = dlsColor('caRed'), size = IconSize.small}: UrgentIconProps) => {
  return (
    <ThemeIconProvider name='UrgentIcon' size={size} color={color} legacyIcon={(
      <svg width={size} height={size} viewBox='0 0 16 16' fill='none'>
        <path d="M8.42953 2.08514C8.23718 1.75099 7.75499 1.75109 7.56277 2.08531L1.09695 13.3277C0.905237 13.661 1.14585 14.077 1.53038 14.077H14.4679C14.8525 14.077 15.0931 13.6609 14.9013 13.3275L8.42953 2.08514Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M7.99414 5.75781V10.0106" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M7.99414 10.7773V11.9531" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      </svg>
    )} />
  );
};
